import type { ReactNode } from 'react';

import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';

import { CloseIcon } from '@shared/ui/icons';

type SideDialogProps = {
  open: boolean;
  onClose: () => void;
  icon?: ReactNode;
  title: string;
  children: ReactNode;
};

export const SideDialog = (props: SideDialogProps) => {
  const { open, onClose, icon, title, children } = props;

  return (
    <Dialog variant="right" open={open} onClose={onClose}>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box display="flex" alignItems="center" gap={2}>
          {icon && (
            <IconButton variant="pill" sx={{ padding: 1 }}>
              {icon}
            </IconButton>
          )}
          <Box sx={{ flex: 1 }}>
            <Typography fontWeight={600}>{title}</Typography>
          </Box>
        </Box>

        <IconButton onClick={onClose} sx={{ alignSelf: 'flex-start' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          width: 388,
          overflow: 'hidden',
          flex: 1,
          minHeight: 0,
        }}
      >
        {children}
      </DialogContent>
    </Dialog>
  );
};
